export default __webpack_public_path__ + "static/card-6-17035d4747c370d345f3e3d5c9fefac1.png";